import * as yup from 'yup'

export const tdSynnexIntegrationCredentialMetadataSchema = yup
  .object({
    refreshTokenExpiry: yup.string().required(),
  })
  .strict()

export type TdSynnexIntegrationCredentialMetadata = yup.InferType<
  typeof tdSynnexIntegrationCredentialMetadataSchema
>

export const flexportIntegrationCredentialMetadataSchema = yup
  .object({
    accessToken: yup.string().optional(),
    accessTokenExpiry: yup.string().optional(), // ISO timestamp
  })
  .strict()

export type FlexportIntegrationCredentialMetadata = yup.InferType<
  typeof flexportIntegrationCredentialMetadataSchema
>
